import useUserPermission from "~/hooks/useUserPermission";

const useDatasetAssistant = (): boolean => {
  return useUserPermission("use:agents");
};

export default useDatasetAssistant;
